// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file project/v1/project.proto (package project.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Media } from "../../media/v1/media_pb.js";
import { User } from "../../base/v1/user_pb.js";
import { Asset } from "../../asset/v1/asset_pb.js";

/**
 * @generated from enum project.v1.UnitType
 */
export const UnitType = /*@__PURE__*/ proto3.makeEnum(
  "project.v1.UnitType",
  [
    {no: 0, name: "UNIT_TYPE_INVALID", localName: "INVALID"},
    {no: 1, name: "UNIT_TYPE_RESIDENTIAL_INDIVIDUAL", localName: "RESIDENTIAL_INDIVIDUAL"},
    {no: 2, name: "UNIT_TYPE_RESIDENTIAL_COMMON", localName: "RESIDENTIAL_COMMON"},
    {no: 3, name: "UNIT_TYPE_COMMERCIAL_INDIVIDUAL", localName: "COMMERCIAL_INDIVIDUAL"},
    {no: 4, name: "UNIT_TYPE_COMMERCIAL_COMMON", localName: "COMMERCIAL_COMMON"},
  ],
);

/**
 * @generated from message project.v1.Building
 */
export const Building = /*@__PURE__*/ proto3.makeMessageType(
  "project.v1.Building",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "floors", kind: "message", T: Floor, repeated: true },
    { no: 4, name: "medias", kind: "message", T: Media, repeated: true },
  ],
);

/**
 * @generated from message project.v1.Floor
 */
export const Floor = /*@__PURE__*/ proto3.makeMessageType(
  "project.v1.Floor",
  () => [
    { no: 1, name: "no", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "units", kind: "message", T: Unit, repeated: true },
  ],
);

/**
 * @generated from message project.v1.Unit
 */
export const Unit = /*@__PURE__*/ proto3.makeMessageType(
  "project.v1.Unit",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(UnitType) },
    { no: 4, name: "owner_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "owner_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "owner_phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message project.v1.ProjectDetail
 */
export const ProjectDetail = /*@__PURE__*/ proto3.makeMessageType(
  "project.v1.ProjectDetail",
  () => [
    { no: 1, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "no_of_floors", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "no_of_units", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "date_of_completion", kind: "message", T: Timestamp },
    { no: 5, name: "buildings", kind: "message", T: Building, repeated: true },
  ],
);

/**
 * @generated from message project.v1.Project
 */
export const Project = /*@__PURE__*/ proto3.makeMessageType(
  "project.v1.Project",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "project_detail", kind: "message", T: ProjectDetail },
    { no: 5, name: "users", kind: "message", T: User, repeated: true },
    { no: 6, name: "medias", kind: "message", T: Media, repeated: true },
    { no: 7, name: "assets", kind: "message", T: Asset, repeated: true },
    { no: 8, name: "created_at", kind: "message", T: Timestamp },
    { no: 9, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message project.v1.ProjectTaskCounts
 */
export const ProjectTaskCounts = /*@__PURE__*/ proto3.makeMessageType(
  "project.v1.ProjectTaskCounts",
  () => [
    { no: 1, name: "project", kind: "message", T: Project },
    { no: 2, name: "open_tasks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "in_progress_tasks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "closed_tasks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "total_tasks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

